import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    data: null,
    deleted: false,
    error: false
};

export const emailTemplateDetailSlice = createSlice({
    name: 'emailTemplateDetail',
    initialState,
    reducers: {
        getEmailTemplateDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getEmailTemplateDetailSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getEmailTemplateDetailFailure: (state, action) => {
            state.loading = false;
        },
        createEmailTemplateDetail: (state, action) => {
            state.loading = true;
        },
        createEmailTemplateDetailSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        createEmailTemplateDetailFailure: (state, action) => {
            state.loading = false;
        },
        editEmailTemplateDetail: (state, action) => {
            state.loading = true;
        },
        editEmailTemplateDetailSuccess: (state, action) => {
            // state.data = action.payload;
            state.loading = false;
        },
        editEmailTemplateDetailFailure: (state, action) => {
            state.loading = false;
        },
        createEmailTemplateVersionDetail: (state, action) => {
            state.loading = true;
        },
        createEmailTemplateVersionDetailSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        createEmailTemplateVersionDetailFailure: (state, action) => {
            state.loading = false;
        },
        editEmailTemplateVersionDetail: (state, action) => {
            state.loading = true;
        },
        editEmailTemplateVersionDetailSuccess: (state, action) => {
            state.loading = false;
        },
        editEmailTemplateVersionDetailFailure: (state, action) => {
            state.loading = false;
        },
        deleteEmailTemplateDetail: (state, action) => {
            state.loading = true;
        },
        deleteEmailTemplateDetailSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteEmailTemplateDetailFailure: (state, action) => {
            state.loading = false;
        },
        deleteEmailTemplateVersionDetail: (state, action) => {
            state.loading = true;
        },
        deleteEmailTemplateVersionDetailSuccess: (state, action) => {
            state.loading = false;
        },
        deleteEmailTemplateVersionDetailFailure: (state, action) => {
            state.loading = false;
        },
        activateEmailTemplateVersionDetail: (state, action) => {
            state.loading = true;
        },
        activateEmailTemplateVersionDetailSuccess: (state, action) => {
            state.loading = false;
        },
        activateEmailTemplateVersionDetailFailure: (state, action) => {
            state.loading = false;
        },
        testEmailTemplateVersionDetail: (state, action) => {
            state.loading = true;
        },
        testEmailTemplateVersionDetailSuccess: (state, action) => {
            state.loading = false;
        },
        testEmailTemplateVersionDetailFailure: (state, action) => {
            state.loading = false;
        },
        clearEmailTemplateDetail: (state) => initialState,
    },
});
export const {
    activateEmailTemplateVersionDetail,
    activateEmailTemplateVersionDetailSuccess,
    activateEmailTemplateVersionDetailFailure,
    clearEmailTemplateDetail,
    createEmailTemplateDetail,
    createEmailTemplateDetailFailure,
    createEmailTemplateDetailSuccess,
    createEmailTemplateVersionDetailFailure,
    createEmailTemplateVersionDetailSuccess,
    createEmailTemplateVersionDetail,
    deleteEmailTemplateDetail,
    deleteEmailTemplateDetailFailure,
    deleteEmailTemplateDetailSuccess,
    deleteEmailTemplateVersionDetail,
    deleteEmailTemplateVersionDetailSuccess,
    deleteEmailTemplateVersionDetailFailure,
    editEmailTemplateDetail,
    editEmailTemplateDetailFailure,
    editEmailTemplateVersionDetailFailure,
    editEmailTemplateDetailSuccess,
    editEmailTemplateVersionDetailSuccess,
    editEmailTemplateVersionDetail,
    getEmailTemplateDetailFetch,
    getEmailTemplateDetailFailure,
    getEmailTemplateDetailSuccess,
    testEmailTemplateVersionDetail,
    testEmailTemplateVersionDetailSuccess,
    testEmailTemplateVersionDetailFailure
} = emailTemplateDetailSlice.actions;


export default emailTemplateDetailSlice.reducer;
